import swal from 'sweetalert2';
import { downloadPDF, downloadVideo } from "../api/fileAPI";


export const getDeviceDetails = async(deviceData) => {

    if(deviceData && (deviceData.isMobile || deviceData.isTablet)){
      return `${deviceData.os} ${deviceData.osVersion}`
    }else{
      return`${deviceData.osName} ${deviceData.osVersion}-${deviceData.browserName}`
    }
};

export const camelCase = (data) =>
  !data || data === ''
    ? ''
    : data
      .replace(/\s+/g, ' ')
      .split(' ')
      .map((d) => capitalizeCamel(d))
      .join(' ');

export const capitalizeCamel = (name) =>
  !name || name === ''
    ? ''
    : `${name[0].toUpperCase()}${name.slice(1).toLowerCase()}`;


export const email = (data) =>
  !data || data === ''
    ? ''
    : data
      .replace(/\s+/g, '')
      .toLowerCase()
      .trim();

export const contact = (data) =>
  !data || data === ''
    ? ''
    : data
        .replace(/[^+\d]/g, '')
        .replace(/\+(?=.*\+)/g, '')
        .trim()
        .slice(0, 15);


export const downloadAndOpenPDFHandler = async (clientId) => {
  try {
    swal.fire({
      titleText           : 'Loading',
      text                : 'Please Wait...',
      showConfirmButton   : false,
      allowOutsideClick   : false,
      didOpen: () => {
          swal.showLoading();
      }
    });
    const res =  await downloadPDF(clientId);
    if (res) {
      const blob = new Blob([new Uint8Array(res.File.data)], { type: "application/pdf" });
      swal.close();
      const newTab = window.open('', '_blank');
      const url = URL.createObjectURL(blob);
      newTab.location.href = url;
    } 
  } catch (err) {
    swal.close();
    swal.fire({ icon: "error", titleText: "Error!", text: "Failed to generate PDF" });
  }
}

export const downloadVideoHandler = async (clientId) => {
  try {
    swal.fire({
      titleText           : 'Loading Video',
      text                : 'Please Wait...',
      showConfirmButton   : false,
      allowOutsideClick   : false,
      didOpen: () => {
          swal.showLoading();
      }
    });
    const res =  await downloadVideo(clientId);
    if (res) {
      const blob = new Blob([new Uint8Array(res)], { type: "video/mp4" });
      swal.close();
      return blob
    } 
  } catch (err) {
    swal.close();
    swal.fire({ icon: "error", titleText: "Error!", text: "Failed to download video" });
  }
}

export const countryCodes = [
  { value: "+1", label: "United States (+1)" },
  { value: "+91", label: "India (+91)" },
  { value: "+44", label: "United Kingdom (+44)" },
  { value: "+81", label: "Japan (+81)" },
  { value: "+61", label: "Australia (+61)" },
  { value: "+93", label: "Afghanistan (+93)" },
  { value: "+355", label: "Albania (+355)" },
  { value: "+213", label: "Algeria (+213)" },
  { value: "+376", label: "Andorra (+376)" },
  { value: "+244", label: "Angola (+244)" },
  { value: "+54", label: "Argentina (+54)" },
  { value: "+374", label: "Armenia (+374)" },
  { value: "+43", label: "Austria (+43)" },
  { value: "+994", label: "Azerbaijan (+994)" },
  { value: "+973", label: "Bahrain (+973)" },
  { value: "+880", label: "Bangladesh (+880)" },
  { value: "+375", label: "Belarus (+375)" },
  { value: "+32", label: "Belgium (+32)" },
  { value: "+501", label: "Belize (+501)" },
  { value: "+229", label: "Benin (+229)" },
  { value: "+975", label: "Bhutan (+975)" },
  { value: "+591", label: "Bolivia (+591)" },
  { value: "+387", label: "Bosnia and Herzegovina (+387)" },
  { value: "+267", label: "Botswana (+267)" },
  { value: "+55", label: "Brazil (+55)" },
  { value: "+673", label: "Brunei (+673)" },
  { value: "+359", label: "Bulgaria (+359)" },
  { value: "+226", label: "Burkina Faso (+226)" },
  { value: "+257", label: "Burundi (+257)" },
  { value: "+855", label: "Cambodia (+855)" },
  { value: "+237", label: "Cameroon (+237)" },
  { value: "+1", label: "Canada (+1)" },
  { value: "+238", label: "Cape Verde (+238)" },
  { value: "+236", label: "Central African Republic (+236)" },
  { value: "+235", label: "Chad (+235)" },
  { value: "+56", label: "Chile (+56)" },
  { value: "+86", label: "China (+86)" },
  { value: "+57", label: "Colombia (+57)" },
  { value: "+269", label: "Comoros (+269)" },
  { value: "+242", label: "Congo (+242)" },
  { value: "+243", label: "Congo (DRC) (+243)" },
  { value: "+682", label: "Cook Islands (+682)" },
  { value: "+506", label: "Costa Rica (+506)" },
  { value: "+385", label: "Croatia (+385)" },
  { value: "+53", label: "Cuba (+53)" },
  { value: "+357", label: "Cyprus (+357)" },
  { value: "+420", label: "Czech Republic (+420)" },
  { value: "+45", label: "Denmark (+45)" },
  { value: "+253", label: "Djibouti (+253)" },
  { value: "+1-767", label: "Dominica (+1-767)" },
  { value: "+1-809", label: "Dominican Republic (+1-809)" },
  { value: "+593", label: "Ecuador (+593)" },
  { value: "+20", label: "Egypt (+20)" },
  { value: "+503", label: "El Salvador (+503)" },
  { value: "+240", label: "Equatorial Guinea (+240)" },
  { value: "+291", label: "Eritrea (+291)" },
  { value: "+372", label: "Estonia (+372)" },
  { value: "+251", label: "Ethiopia (+251)" },
  { value: "+679", label: "Fiji (+679)" },
  { value: "+358", label: "Finland (+358)" },
  { value: "+33", label: "France (+33)" },
  { value: "+241", label: "Gabon (+241)" },
  { value: "+220", label: "Gambia (+220)" },
  { value: "+995", label: "Georgia (+995)" },
  { value: "+49", label: "Germany (+49)" },
  { value: "+233", label: "Ghana (+233)" },
  { value: "+30", label: "Greece (+30)" },
  { value: "+502", label: "Guatemala (+502)" },
  { value: "+224", label: "Guinea (+224)" },
  { value: "+245", label: "Guinea-Bissau (+245)" },
  { value: "+592", label: "Guyana (+592)" },
  { value: "+509", label: "Haiti (+509)" },
  { value: "+504", label: "Honduras (+504)" },
  { value: "+852", label: "Hong Kong (+852)" },
  { value: "+36", label: "Hungary (+36)" },
  { value: "+354", label: "Iceland (+354)" },
  { value: "+62", label: "Indonesia (+62)" },
  { value: "+98", label: "Iran (+98)" },
  { value: "+964", label: "Iraq (+964)" },
  { value: "+353", label: "Ireland (+353)" },
  { value: "+972", label: "Israel (+972)" },
  { value: "+39", label: "Italy (+39)" },
];
